import { ClaimSummaryComponent } from '@components/my-claims/claim-summary/claim-summary.component';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ClaimInformation } from 'app/interfaces/claim-information';
import { CreateClaimTabInfo } from 'app/interfaces/create-claim-tab-info';

@Component({
  selector: 'app-claim-summary-on-creation',
  standalone: true,
  imports: [ClaimSummaryComponent],
  templateUrl: './claim-summary.component.html',
  styleUrl: './claim-summary.component.scss'
})
export class ClaimSummaryOnCreationComponent implements OnInit{
    @Input() claimId!: string
    @Output() tabInit = new EventEmitter<CreateClaimTabInfo>()
    @Output() updateClaim = new EventEmitter<ClaimInformation>()

    ngOnInit() {
        this.tabInit.emit({
            currentTab: 'summary',
            previousTab: 'documentation',
            nextTab: 'finish'
        })
    }

}
